<div class="navbar-wrapper">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/region']" role="button" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        <i-bs name="house-door" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Dashboard</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/region/sanctioned-posts"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Post/Vacancy</span>
      </a>
      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/region/sanctioned-posts"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> S </span>
              <span class="sidenav-normal"> Sanctioned Post </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/region/sanctioned-posts/vacant-posts"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> V </span>
              <span class="sidenav-normal"> Vacant Post </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/region/employee-profile']" role="button" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Employee Profile</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/region/employees"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Employee (Approval)</span>
      </a>
      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/region/employees"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> E </span>
              <span class="sidenav-normal"> Approval-I (Biodata) </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/region/employees/transfer-requests"]' routerLinkActive="active"
              [queryParams]="{financialYearId:setting?.financialYearId, phaseId: setting?.phaseId}" class="nav-link">
              <span class="sidenav-mini-icon"> T </span>
              <span class="sidenav-normal"> Approval-II (Transfer Request) </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>